import type { InboxRepository } from '@/domain/inbox/Inbox'

export async function markNotificationsRead(inbox: InboxRepository, ids: readonly number[]): Promise<void> {
  if (ids.length === 0) return
  await inbox.markRead([...ids])
}
